export default __webpack_public_path__ + "static/media/no_produc_found.11c9fb5f.png";